import { ADD_QUEUE_POSITION, ADD_QUEUE_POSITION_ERROR, ADD_QUEUE_POSITION_SUCCESS } from "./actionTypes";

export const addQueuePosition = (ws_pos, queue_init, queue_end, confirmation_point, token, history) => {
  return {
    type: ADD_QUEUE_POSITION,
    payload: { ws_pos, queue_init, queue_end, confirmation_point, token, history },
  };
};

export const addQueuePositionSuccess = (message, addedQueue) => {
  return {
    type: ADD_QUEUE_POSITION_SUCCESS,
    payload: { message, addedQueue },
  };
};

export const addQueuePositionError = (message) => {
  return {
    type: ADD_QUEUE_POSITION_ERROR,
    payload: message,
  };
};
